import React from 'react';
import PropTypes from 'prop-types';
import { StyledModal, StyledModalHeader } from '../../form/FormElements';

function PopupWindow({
  visible,
  headerTitle,
  question,
  customSettings,
  toggle,
}) {
  return (
    <StyledModal
      style={{
        transform: 'translate(0px, 0px)',
        transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
      }}
      open={visible}
      size="xs"
      onCancel={() => toggle()}
      footer={null}
    >
      <StyledModalHeader>
        <span className="second-title">{headerTitle}</span>
      </StyledModalHeader>
      <div style={{ padding: '5px' }}>
        <div className="question-modal-msg">{question}</div>
        {customSettings}
      </div>
    </StyledModal>
  );
}

PopupWindow.propTypes = {
  visible: PropTypes.bool,
  toggle: PropTypes.func,
  headerTitle: PropTypes.string,
  question: PropTypes.string,
  customSettings: PropTypes.any,
};

export default PopupWindow;
